export default {"src":"/_next/static/media/logo-lazo.8adcf8cd.svg","height":55,"width":139,"blurWidth":0,"blurHeight":0};